import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'emodnet-fe-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
